<template>
    <div class="trees">
			<el-scrollbar style="height:100%">
			<el-tree
			ref='tree'
			:data="handleAllStations"
			:props="defaultProps"
			@node-click="handleTreeClick" 
			node-key="id" 
			:highlight-current="true"
			:show-checkbox="false"
			:expand-on-click-node=false
			:default-expanded-keys="['001']"
			 >
             <span slot-scope="{node}">
						<span v-if="node.level==1" >{{node.label}}</span>
						<span v-if="node.level==2" class="stationClass">{{node.label}}</span>
						
						
					
					</span>
			</el-tree>
			</el-scrollbar>
		</div>
</template>
<script>
import{getAllStationList} from "@/api/url"
export default {
    data(){
        return{
            allStations:[ ],
            defaultProps: {
		        children: 'children',
		        label: 'label'
		    }
        }
    },
    methods:{
        getAllStations(){
            this.$get(getAllStationList()).then(data=>{
                if(data.status!=200) return;
                this.allStations=data.data.rows;
                // console.log("this.allStations")
                // console.log(this.allStations)
            })
        },
        handleTreeClick(node,data){
            this.$emit("handleTreeClick",node,data)
		},
		setCurrent(id){
			this.$refs.tree.setCurrentKey(id);
		},
    },
    created(){
        
    },
    mounted(){
        this.getAllStations();
    },
    computed:{
        handleAllStations(){
             var jsTreeDatas=[];
            if(this.allStations.length!=0){
               
					var itemZero={
						onlyId:'',
						id:'001',
						label:"全部",
						level:"0",
						children:[]
					};
					var allDatas=this.allStations;
					for(let index1 in allDatas){
						
					//一级目录
					let itemOne={
						onlyId:'',
						id:"",
						label:"",
						level:"1",
						children:[]
					};
					itemOne.onlyId='1_'+index1;
					itemOne.id=allDatas[index1].stationId;
					itemOne.label=allDatas[index1].stationSn;
					itemZero.children.push(itemOne);
					}
					jsTreeDatas.push(itemZero);
				
            }
            // console.log("jsTreeDatas")
			// console.log(jsTreeDatas)
            return jsTreeDatas;
        },
    }


}

</script>
<style>
.el-tree{
		color:#5c5c5c !important;
		/*background-color:#eff2f7 !important;*/
		height:650px;
		overflow:auto;
		padding-bottom:20px;
	}
	
	.trees{
	
		border-right:10px solid  #eff2f7;
		
	}
	.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
		background:#ccc!important;
	}
	
	.isActive{
		background:#ccc!important;
	}
	.el-tree{
    color:#5c5c5c !important;
    /*background-color:#eff2f7 !important;*/
    height:650px;
    overflow:auto;
}

.trees{

    border-right:10px solid  #eff2f7;
    padding:10px 5px 20px 5px;
    
}
.stationClass{
		
    display:inline-block;
    
    height:15px;
    line-height: 15px;
    /*background-color:#278cd8;*/
        background: url('../../../../assets/images/station.png');
        padding-left:20px;
        /*font-weight: bold;*/
        color:#606266;
        font-size:14px;
         
    
}
</style>